// JsFromRoutes CacheKey 98ac02fab9792f097fe98055b99b2940
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/diagnoses/:id/matches'),
  purchase: /* #__PURE__ */ definePathHelper('post', '/theses/:id/purchase'),
  latestNewsArticles: /* #__PURE__ */ definePathHelper('get', '/theses/:id/latest_news_articles'),
  toggleNotificationPreference: /* #__PURE__ */ definePathHelper('post', '/theses/:id/toggle_notification_preference'),
  show: /* #__PURE__ */ definePathHelper('get', '/theses/:id'),
}
